import GalleryModal from "modal/GalleryModal";

export default function handleGalleryGridElements() {
    let $gallery_items = $('.js-gallery-modal');


    if ($gallery_items.length > 0) {
        $gallery_items.each(function () {
            let $this = $(this);
            let modal = new GalleryModal($this);

            $this.on('click', '.js-open-modal', function () {
                let index = $(this).attr('data-index');
                modal.show();
                modal.setActive(index);

                return false;
            });
        });
    }
}
